import { rootStateBranchSelector } from '@/packages/redux-state/store/utils/rootStateBranchSelector';

export const selectComparisonNotificationState = rootStateBranchSelector('comparisonNotification');
